// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".flatpickr-calendar{box-shadow:var(--stan-box-shadow)}.flatpickr-calendar.arrowTop:before{border-bottom:none}", "",{"version":3,"sources":["webpack://src/components/shared/AppFilterChip.vue"],"names":[],"mappings":"AAAA,oBAAoB,iCAAiC,CAAC,oCAAoC,kBAAkB","sourcesContent":[".flatpickr-calendar{box-shadow:var(--stan-box-shadow)}.flatpickr-calendar.arrowTop:before{border-bottom:none}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
